import React, { useEffect, useState } from 'react';
import styles from './Accordion.styles';
import Icons from '../icons/Icons';
import { Theme } from '../constants';
import { VEC_ICON_NAME } from '../icons/constants';

export default function Accordion({ header, body, customStyles, customizationInfo = {}, active = false, onClickCb = () => { } }) {

    const [isActive, setIsActive] = useState(false);
    const iconColor = (customizationInfo.colors && customizationInfo.colors.secondary) ? customizationInfo.colors.secondary : Theme.PRIMARY;

    useEffect(() => {
        setIsActive(active)
    }, [active])

    return (
        <li style={{ ...styles.accordionItem, ...(isActive ? styles.accordionItemColorActive : styles.accordionItemColor) }}>
            <div
                style={{ ...styles.accordionToggle, ...customStyles }}
                onClick={() => {
                    setIsActive(!isActive)
                    onClickCb()
                }}
            >
                <span style={styles.toggleIcon}>
                    {
                        isActive ?
                            <Icons familyName={'vec'} iconName={VEC_ICON_NAME.CARET_DOWN} color={iconColor} />
                            :
                            <Icons familyName={'vec'} iconName={VEC_ICON_NAME.CARET_DOWN} color={iconColor} rotateDeg={150} />
                    }
                </span>
                {header}
            </div>
            {isActive && <div style={styles.accordionContent}>{body}</div>}
        </li>
    )
}